import month from './calendar-month';
import week from './calendar-week';

export default [...month, ...week];
